import axios from "axios";
import apis from "../../../../lib/apis/apis";
import { apiHeaders } from "../../../../lib/apiHeader";
import { mockStatus, mockConnect, mockDisconnect } from "./mockSquareData";

// Flip to false when the Laravel endpoints from the spec's §6 contract ship.
export const USE_SQUARE_MOCKS = true;

const delay = (data, ms = 400) =>
  new Promise((resolve) => setTimeout(() => resolve(data), ms));

const get = async (url, params) => {
  const response = await axios.get(url, { params, headers: apiHeaders() });
  if (response?.data?.success === "true") return response.data.data;
  throw new Error(response?.data?.message || "Request failed");
};

const post = async (url, payload) => {
  const response = await axios.post(url, payload, { headers: apiHeaders() });
  if (response?.data?.success === "true") return response.data.data;
  throw new Error(response?.data?.message || "Request failed");
};

export const squareApi = {
  getStatus: async (params) =>
    USE_SQUARE_MOCKS ? delay(mockStatus(params)) : get(apis.square_oauth_status, params),
  connect: async (payload) =>
    USE_SQUARE_MOCKS ? delay(mockConnect(payload), 900) : post(apis.square_oauth_connect, payload),
  disconnect: async (payload) =>
    USE_SQUARE_MOCKS ? delay(mockDisconnect(payload)) : post(apis.square_oauth_disconnect, payload),
};
